// extracted by mini-css-extract-plugin
export default {"related-content-header":"Related_related-content-header__9JnZ8","related-content-header-thumbnail":"Related_related-content-header-thumbnail__VnJA+"};